import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["CheckboxesDropdownComponent"], {
    id: $props.filterKey,
    label: $props.label,
    placeholder: $props.placeholder,
    options: $setup.options,
    query: $setup.filter.search_query,
    selection: $setup.active_values,
    stretch: true,
    "search-disabled": $props.searchDisabled,
    loading: $setup.loading,
    onSelect: $setup.handleValueSelect,
    "onUpdate:query": $setup.handleSearchInputChange
  }, null, 8 /* PROPS */, ["id", "label", "placeholder", "options", "query", "selection", "search-disabled", "loading"]))
}